import React from 'react';
import { Grid, Box, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import MDUIIconButton from '../m3/iconButton';
import MDUIButton from '../m3/button';
import styles from './styles';

function Footer({
  handleNextStep,
  isEnableNextStep = true,
  handlePrevStep,
  nextStepBtnLabel = '',
  prevStepBtnLabel = '',
  otherBtnLabel = '',
  handleAction,
  hasBackButton = true,
  hasMargin = false
}) {
  const theme = useTheme();
  const classes = styles(theme, hasMargin);
  return (
    <Box sx={classes.boxContainer} id="footer">
      <Grid container spacing={2} sx={classes.container}>
        <Grid item sx={classes.buttonGroup}>
          {!hasBackButton ? null : prevStepBtnLabel ? (
            <MDUIButton
              icon="chevron_left"
              variant="outlined"
              style={{ ...classes.prevButton, ...classes.button }}
              onClick={handlePrevStep}
            >
              {prevStepBtnLabel}
            </MDUIButton>
          ) : (
            <MDUIIconButton
              onClick={handlePrevStep}
              style={{ ...classes.prevButton, ...classes.button }}
              icon="chevron_left"
              variant="outlined"
            />
          )}
        </Grid>
        <Grid item sx={classes.buttonGroup}>
          {!otherBtnLabel ? null : (
            <MDUIButton
              variant="outlined"
              onClick={handleAction}
              style={{ ...classes.prevButton, ...classes.button }}
            >
              {otherBtnLabel}
            </MDUIButton>
          )}
          {nextStepBtnLabel && (
            <MDUIButton
              style={{
                ...classes.nextButton,
                ...classes.button,
                ...(!isEnableNextStep ? classes.disabledButton : {})
              }}
              onClick={handleNextStep}
              disabled={!isEnableNextStep}
            >
              {nextStepBtnLabel}
            </MDUIButton>
          )}
          <MDUIIconButton
            style={{ ...classes.questionIcon, ...classes.button }}
            variant="outlined"
            icon="question_mark"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

Footer.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  isEnableNextStep: PropTypes.bool,
  handlePrevStep: PropTypes.func.isRequired,
  handleAction: PropTypes.func,
  nextStepBtnLabel: PropTypes.string,
  prevStepBtnLabel: PropTypes.string,
  otherBtnLabel: PropTypes.string,
  hasBackButton: PropTypes.bool,
  hasMargin: PropTypes.bool
};

export default Footer;
